export default __webpack_public_path__ + "static/media/salud.d499bfc6.svg";